<template>
  <v-container fluid style="padding-left: 100px">
    <h1>プロフィール設定</h1>
    <ProfileSettingForm></ProfileSettingForm>
  </v-container>
</template>

<script>
import ProfileSettingForm from '@/components/commons/ProfileSettingForm.vue'

export default {
  components: { ProfileSettingForm }
}
</script>
